module.exports = __webpack_public_path__ + "static/media/eye-dropper.2549680f.svg";